// Control de Asistencia (kiosko "pasar lista") · entrada SINGLE-DOOR desde el CRM.
//
// Esta página es la entrada clásica (PR #776, aprobada por Ann): un usuario del
// CRM con el permiso `asistencia.control.pasar-lista` abre /control-asistencia y
// pasa lista. El diseño aprobado vive ahora en el componente reutilizable
// <PasarLista/> (frontend/src/pages/vista-en-sala/PasarLista.jsx).
//
// La VISTA EN SALA (kiosko de 2 puertas, sesión de sala) reutiliza ese mismo
// <PasarLista/> como su sección ASISTENCIA → ver /vista-en-sala (VistaSalaShell).
//
// SEGURIDAD
//  - Gate al permiso `asistencia.control.pasar-lista` (deny-by-default). El
//    permiso/rol los registra el GUARDIÁN; aquí solo se LEE el flag.
//  - No toca AuthContext ni el schema de permisos.

import React, { useContext, useMemo } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import PasarLista from "./vista-en-sala/PasarLista";
import "./control-asistencia.css";

const ControlAsistenciaPage = () => {
  const { user, isAdmin } = useContext(AuthContext) || {};

  // Gate local (no toca el motor de permisos · lo registra el Guardián).
  const permitido = useMemo(() => {
    if (!user) return false;
    if (isAdmin) return true;
    const pg = user?.permisos_granulares || {};
    return pg["asistencia.control"]?.["ver"] === true;
  }, [user, isAdmin]);

  if (!user) return <Navigate to="/" replace />;
  if (!permitido) {
    return (
      <div className="ca-app">
        <div className="ca-gate">
          <h2>Control de Asistencia</h2>
          <p>No tienes permiso para pasar lista. Pide acceso al administrador
          (permiso <code>Control de Asistencia · ver</code>).</p>
        </div>
      </div>
    );
  }

  return (
    <div className="ca-app">
      <PasarLista />
    </div>
  );
};

export default ControlAsistenciaPage;
